import React from 'react';
import { TrendingUp, AlertTriangle, CheckCircle, Zap } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const AutomationMetrics = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Batch Success Rate',
      value: `${metrics?.batchSuccessRate || 0}%`,
      icon: CheckCircle,
      color: 'green',
      trend: '+2.3%',
      trendUp: true
    },
    {
      label: 'Anomalies Detected',
      value: metrics?.anomaliesDetected || 0,
      icon: AlertTriangle,
      color: 'orange',
      trend: '-12%',
      trendUp: false
    },
    {
      label: 'Auto-Resolved Discrepancies',
      value: metrics?.autoResolvedDiscrepancies || 0,
      icon: Zap,
      color: 'blue',
      trend: '+18%',
      trendUp: true
    },
    {
      label: 'Processing Efficiency',
      value: `${metrics?.processingEfficiency || 0}%`,
      icon: TrendingUp,
      color: 'purple',
      trend: '+5.2%',
      trendUp: true
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      green: 'bg-green-50 text-green-700 border-green-200',
      orange: 'bg-orange-50 text-orange-700 border-orange-200',
      blue: 'bg-blue-50 text-blue-700 border-blue-200',
      purple: 'bg-purple-50 text-purple-700 border-purple-200'
    };
    return colors?.[color] || colors?.blue;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metricCards?.map((metric, index) => {
        const Icon = metric?.icon;
        return (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-4"
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`p-2 rounded-lg border ${getColorClasses(metric?.color)}`}>
                <Icon className="w-5 h-5" />
              </div>
              <span className={`text-xs font-medium px-2 py-1 rounded ${
                metric?.trendUp ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
              }`}>
                {metric?.trend}
              </span>
            </div>
            <div className="text-2xl font-bold text-gray-900 mb-1">
              {metric?.value}
            </div>
            <div className="text-sm text-gray-600">
              {metric?.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AutomationMetrics;